import { Button } from '@mui/material'

import makeStyles from '@mui/styles/makeStyles'
import withStyles from '@mui/styles/withStyles'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    marginRight: '1rem',
    border: '0.0625rem solid #F1F1F1',
    borderRadius: '1rem',
    boxSizing: 'border-box',
    boxShadow: '0 4px 6px 0 rgba(66,81,89,0.05)',
    minWidth: '480px',
    // @ts-ignore
    maxHeight: ({ isConsentVisible }) =>
      isConsentVisible
        ? 'calc(100svh - 80px - 1rem - 52px)'
        : 'calc(100svh - 80px - 1rem)',
    backgroundColor: 'white',

    [theme.breakpoints.down(767)]: {
      width: '100%',
      marginRight: '0',
      border: 'none',
      borderRadius: '0'
    }
  },

  topArea: {
    display: 'flex',
    flexDirection: 'column',
    flexShrink: 0,
    padding: '0.5rem 1.75rem 0 1.75rem'
  },

  queueArea: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexShrink: 0
  },

  queueTitle: {
    fontSize: theme.size.base,
    color: '#323436'
  },

  switch: {
    marginTop: '2px',
    marginRight: '7px'
  },

  queueOptions: {
    display: 'flex',
    flexWrap: 'wrap',
    fontSize: theme.size.base,

    '& > div': {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexWrap: 'nowrap',
      marginLeft: 'auto'
    },

    '& .title': {
      marginTop: '0.125rem',
      fontSize: theme.size.sm,
      userSelect: 'none',
      whiteSpace: 'nowrap',
      color: '#7F8487'
    },

    '& .count': {
      display: 'flex',
      flexShrink: 0,
      color: '#323436',
      fontSize: theme.size.sm
    },

    '& .current': {
      marginRight: '4px',
      color: theme.palette.primary.main,
      fontSize: theme.size.sm
    }
  },

  spacer: {
    flex: '1 1 auto'
  },

  menuItem: {
    display: 'flex',
    alignItems: 'center',
    margin: '0.5rem 0.25rem',
    cursor: 'pointer',
    fontSize: theme.size.sm
  },

  menuIcon: {
    marginRight: '0.625rem',
    fontSize: theme.size.base,
    color: theme.palette.primary.main
  },

  select: {
    textAlign: 'right',
    color: theme.palette.primary.main,
    userSelect: 'none',
    cursor: 'pointer',
    fontSize: theme.size.sm,

    '&:hover': {
      textDecoration: 'underline'
    }
  },

  empty: {
    borderTop: '0.0625rem solid #F1F1F1',
    width: '100%',
    paddingTop: '0.5rem',
    textAlign: 'center'
  },

  conversations: {
    overflowY: 'hidden',
    minHeight: 'calc(100% - 7rem)',
    height: '0',
    maxWidth: '100%',

    '& > *': {
      borderTop: '0.0625rem solid #F1F1F1'
    },

    '& > :last-child': {
      borderBottom: '0.0625rem solid #F1F1F1'
    },

    '&:hover': {
      overflowY: 'auto',
      overflowX: 'hidden'
    },
    [theme.breakpoints.down('sm')]: {
      overflowY: 'auto'
    }
  },

  archive: {
    position: 'absolute',
    bottom: '9px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%'
  },

  loading: {
    margin: '1rem auto'
  }
}))

export const StyledButton = withStyles(theme => ({
  root: {
    borderRadius: '50%',
    width: '2rem',
    minWidth: '2rem',
    height: '2rem',
    minHeight: '2rem',
    // @ts-ignore
    background: `linear-gradient(276deg, ${theme.gradient.button.start} 0%, ${theme.gradient.button.stop} 100%)`,
    fontSize: theme.size.xxl,
    color: 'white'
  }
}))(Button)

export default useStyles
